module.exports = __webpack_public_path__ + "static/img/googlestorewht.74f8a17a.png";